export default __webpack_public_path__ + "ff957846a528beb1837b75e7972e8ba8.png";